import { render, staticRenderFns } from "./VGallery.vue?vue&type=template&id=cafe9816"
import script from "./VGallery.vue?vue&type=script&lang=js"
export * from "./VGallery.vue?vue&type=script&lang=js"
import style0 from "./VGallery.vue?vue&type=style&index=0&id=cafe9816&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports